module.exports = __webpack_public_path__ + "static/media/vaneyk-14.57d3b761.jpeg";